import { IAuthor } from '@shared/models/author.model';

export const MOVIMENTACOES_PAGE_LIMIT = 50;
export const MOVIMENTACOES_LOTE_LIMIT = 50;

export type TSortDirection = 'ASC' | 'DESC';
export type TMovimentacaoOrderField = 'ordem' | 'trabalhador.nome' | 'evento.nome' | 'lotacao.nome';
export type TMovimentacaoHistoricoOrderField = 'ordem';

export interface IMovimentacoesConstructor {
    movimentacaoperiodo?: string;
}

export interface IMovimentacaoSituacaoFilterExpression {
    condition: 'eq' | 'neq';
    value: number | string;
}

export interface IMovimentacaoWorkflowEstadoFilterExpression {
    condition: 'eq' | 'neq';
    value: string;
}

export interface IMovimentacaoListFilters {
    situacao?: IMovimentacaoSituacaoFilterExpression[];
    wkf_estado?: IMovimentacaoWorkflowEstadoFilterExpression[];
    fase?: number | string;
    trabalhador?: string;
    'trabalhador.codigo'?: string;
    evento?: string;
    'evento.codigo'?: string;
    lotacao?: string;
    'lotacao.codigo'?: string;
}

export type IMovimentacaoOrder = Partial<Record<TMovimentacaoOrderField, TSortDirection>>;

export type IMovimentacaoOffset = Partial<Record<TMovimentacaoOrderField, string | number>>;

export interface IMovimentacaoListQuery extends IMovimentacoesConstructor, IMovimentacaoListFilters {
    filter?: string;
    order?: IMovimentacaoOrder;
    offset?: IMovimentacaoOffset;
}

export interface IMovimentacoesPagination {
    currentPage: number;
    pageSize: number;
    totalItems: number;
}

export interface IMovimentacoesMeta {
    fullCount: number | null;
    hasNext: boolean;
}

export interface IMovimentacaoLoteChunkResult {
    processados: number;
    total: number;
    erro?: any;
}

export interface IMovimentacaoListItem {
    movimentacao: string;
    ordem: number;
    colaboradorFotoUrl?: string;
    disableCheckbox?: boolean;
    enableTooltip?: boolean;
    checkboxTooltip?: string;
    movimentacaoperiodo: {
        movimentacaoperiodo: string;
        mes: number;
        ano: number;
        situacao?: number | null;
        encerramentolancamentos?: string | null;
    };
    trabalhador: {
        trabalhador: string;
        codigo: string;
        nome: string;
    };
    evento: {
        evento: string;
        codigo: string;
        nome: string;
        tipovalor: number;
        unidade: number;
    };
    lotacao: {
        lotacao: string;
        codigo: string;
        nome: string;
    };
    valor: string;
    referencia: string | null;
    datapagamento: string | null;
    vigencia: number;
    vigenciamesfinal: number | null;
    vigenciaanofinal: number | null;
    situacao: number;
    versao: number;
    wkf_data: any;
    wkf_estado: any;
    wkf_estado_titulo?: string | null;
    fase?: number;
    /** Elegibilidade do cancelamento de envio, calculada no backend. */
    _podecancelar?: boolean;
    created_at: string;
    created_by: IAuthor;
    full_count?: number | string | null;
}

export interface IMovimentacao extends IMovimentacaoListItem {
    updated_at?: string | null;
    updated_by?: IAuthor | null;
}

export interface IMovimentacaoPayload {
    movimentacaoperiodo: string;
    trabalhador: string;
    evento: string;
    lotacao: string;
    valor: string | number;
    referencia?: string | null;
    datapagamento?: string | null;
    vigencia: number;
    vigenciamesfinal?: number | null;
    vigenciaanofinal?: number | null;
}

export interface IMovimentacaoUpdatePayload {
    evento: string;
    lotacao: string;
    valor: string | number;
    referencia?: string | null;
    datapagamento?: string | null;
    vigencia: number;
    vigenciamesfinal?: number | null;
    vigenciaanofinal?: number | null;
    versao: number;
}

export interface IMovimentacaoCreateResponse {
    movimentacao: string;
}

export interface IMovimentacaoHistoricoDetalhes {
    old?: any;
    new?: any;
    diff?: string[];
}

export interface IMovimentacaoHistoricoResumo {
    movimentacaohistorico: string;
    ordem: number;
    movimentacao: string;
    tipo: number;
    motivo: string | null;
    created_at: string;
    created_by: IAuthor;
    full_count?: number | string | null;
}

export interface IMovimentacaoHistoricoDetalhe extends IMovimentacaoHistoricoResumo {
    detalhes?: IMovimentacaoHistoricoDetalhes;
}

export interface IMovimentacaoHistoricoListQuery {
    tipo?: number | string;
    order?: Partial<Record<TMovimentacaoHistoricoOrderField, TSortDirection>>;
    offset?: Partial<Record<TMovimentacaoHistoricoOrderField, string | number>>;
}

export interface IMovimentacaoResumoAgrupador {
    situacao?: number;
    wkf_estado?: string;
    fase?: number;
}

export interface IMovimentacaoResumoTotais {
    horas: string;
    dias: string;
    outros: string;
}

export interface IMovimentacaoResumoItem {
    agrupador: IMovimentacaoResumoAgrupador | [];
    movimentacoes: number;
    rendimentos: IMovimentacaoResumoTotais;
    descontos: IMovimentacaoResumoTotais;
}
